
/**
 * Moves to the drinks page
 */
function drinksPage() {
	window.location.href = '/pages/drinksPage.html';
}
